<template>
  <el-dialog
    :visible.sync="isVisible"
    title="编辑内容"
    width="80%"
    @close="handleClose"
    :close-on-click-modal="false"
    :fullscreen="fullQ"
  >
    <template #title>
      <span>编辑内容</span>
      <!-- 全屏按钮 -->
      <el-button
        class="fullscreen-btn"
        icon="el-icon-full-screen"
        @click="toggleFullscreen"
        size="small"
        style="float: right; margin-top: 5px"
      ></el-button>
    </template>
    <el-form :model="formData" class="formflex" :rules="rules" ref="form" :inline="true">
      <el-form-item label="配件代码">
        <el-input
          v-model="formData.partCode"
          disabled
          placeholder="请输入配件代码"
        ></el-input>
      </el-form-item>
      <el-form-item label="配件名称">
        <el-input
          v-model="formData.partName"
          disabled
          placeholder="请输入配件名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商名称">
        <el-input
          v-model="formData.supplierName"
          disabled
          placeholder="请输入供应商名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="采购价" prop="purchasePrice">
        <el-input
          ref="purchasePriceInput"
          v-model="formData.purchasePrice"
          placeholder="请输入采购价"
          type="number"
          min="0"
          step="0.01"
          validate-event
          clearable
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button class="lang-but" type="primary" @click="handleSubmit">确定</el-button>
      <el-button class="lang-but" type="primary" plain @click="handleClose">取消</el-button>
    </span>
  </el-dialog>
</template>
  
  <script>
export default {
  name: "ModalForm",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 接收外部传入的数据
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      fullQ: false, //全屏
      isVisible: this.visible,
      formData: {
        partCode: "",
        partName: "",
        supplierName: "",
        purchasePrice: 0,
      },
      rules: {
        purchasePrice: [
          { required: true, message: "采购价不能为空", trigger: "blur" },
        ],
      }, // 表单验证规则
    };
  },
  watch: {
    visible(newVal) {
      this.isVisible = newVal;
    },
    // 监听 data 的变化，每次变化时重新赋值给 formData
    data: {
      handler(newData) {
        // 只有当新数据不为空时才赋值
        if (newData && Object.keys(newData).length) {
          this.formData = { ...newData }; // 将新的 data 值复制到 formData
          // 获取 el-input 的 DOM 引用并调用 blur() 方法
        }
      },
      deep: true, // 设置 deep 为 true，以便监听 data 对象的嵌套变化
      immediate: true, // immediate 为 true，确保在组件加载时立即同步一次 formData
    },
  },
  methods: {
    handleClose() {
      this.$refs.form.clearValidate();
      this.$emit("update:visible", false);
      this.fullQ = false;
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 表单验证通过，执行提交逻辑
          this.$emit("submit", { ...this.formData });
          this.handleClose();
        } else {
          // 验证失败
          this.$DonMessage.warning("采购价不能为空，请检查输入！");
        }
      });
    },
    toggleFullscreen() {
      // 切换全屏状态
      this.fullQ = !this.fullQ;
    },
  },
};
</script>

  <style scoped>
.formflex {
  display: flex;
  justify-content: space-evenly;
}

.fullscreen-btn {
  margin: -2px 30px 0 0 !important;
  border: none !important;
  padding: 5px;
}
</style>
  